import { render, staticRenderFns } from "./reviewCom.vue?vue&type=template&id=6e92a7a5"
import script from "./reviewCom.vue?vue&type=script&lang=js"
export * from "./reviewCom.vue?vue&type=script&lang=js"
import style0 from "./reviewCom.vue?vue&type=style&index=0&id=6e92a7a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports